import { render } from "./PageDetailMetier.vue?vue&type=template&id=f4a306b2&scoped=true"
import script from "./PageDetailMetier.vue?vue&type=script&lang=js"
export * from "./PageDetailMetier.vue?vue&type=script&lang=js"

import "./PageDetailMetier.vue?vue&type=style&index=0&id=f4a306b2&lang=scss&scoped=true"

import exportComponent from "C:\\projets\\salon-metiers-2026\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4a306b2"]])

export default __exports__